<template>
  <div v-scroll-lock="true" class="progress-circular">
    <SvgIcon name="progress-circular" class="progress-circular__icon" />
  </div>
</template>

<script>
export default {
  name: "ProgressCircular",
};
</script>

<style lang="scss">
.progress-circular {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  @include flex-center;
  background: var(--color-text);
  z-index: 99999;

  &__icon {
    stroke: var(--color-light-blue);
    @include size(100px);
  }
}
</style>
